import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/Shared/modules/material.modules';
import { EntitySelectorComponent } from './entity-selector.component';

@NgModule({
    declarations: [
        EntitySelectorComponent
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [
        EntitySelectorComponent
    ]
})
export class EntitySelectorModule { }